import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import Steps from '../../../components/Steps';
import Modal from '../../../components/Modal';
import Alert from '../../../components/Alert';
import { fetchFichasVenta, fetchClientes, clearClientes, searchProformas, clearProformasBuscar, fetchCompanias, fetchAreasVenta, fetchVendedores, clearVendedores, fetchColaboradores, clearColaboradores, fetchEquiposLogisticaDetalle, fetchReglasNegocio,fetchFichaVentaWelcomePackValidar,validateProforma,fetchWelcomePackValidar,obtenerProformaCliente } from '../../../actions';
import validateClient from '../../../utils/validateClient';
import ErrorUIComponent from '../../../utils/ErrorUIComponent';
//import validateProforma from '../../../utils/validateProforma';
import { result } from 'lodash-es';

/*Inicio Req 93426 ebarboza 29 11 2021 */
const AlertWelcomePack = props =>{
  return (
    <div id="toast-container"
      style={{
        display: 'block', position: 'absolute', maxWidth: '350px', maxHeight: '350px',
        overflow: 'hidden', fontSize: '0.875rem', backgroundColor: 'rgba(248, 161, 74, 1)',
        backgroundClip: 'paddingBox', border: '2px solid rgba(0, 0, 0, 9)',
        boxShadow: 'rgb(248 161 74 / 10%) 0px 0.25rem 0.75rem', zIndex: '2000',
        backdropFilter: 'blur(10px)', opacity: '1', borderRadius: '0.65rem', top: '150px',
        left: '40%', width: '50%', height: '160px', color: 'white'
      }}>
      <div style={{ display: '-ms-flexbox', display: '-webkit-flex', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', justifyContent: 'center', alignContent: 'stretch', alignItems: 'flex-start' }}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={{ fontSize: '16px', textAlign: 'center' }}>
            <h3>{props.titulo}</h3>
            <hr/>
            <strong>{props.numProfWelcomePack}</strong>
          </div>
        </div>
        <div style={{  width: '100%', display: 'flex', justifyContent: 'center', minHeight: '40px', overflow: 'hidden'}}>
          <div style={{alignSelf: 'center',fontSize: '14px'}}>
            {props.mensajeWelcomePack}
          </div>
        </div>
      </div>
    </div>
      
  )
}
/*Fin Req 93426 ebarboza 29 11 2021 */


const VACIO = '';
const VAR_REGLA_NEGOCIO = '06';
class NuevaFichaVenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      searchOption: 'cadena',
      searchInput: '',
      lastOption: 'cadena',
      lastInput: '',
      errorMessage: '',
      hasError: false,
      clientTable: false,
      proformTable: false,
      searchByProforma: false,
      stillSearch: true,
      // filters
      areaVentaFilter: '',
      companyFilter: '',
      vendedorId: '',
      vendedorName: '',
      // values for create fdv
      clientId: '',
      clientName: '',
      selectedProform: [],
      observaciones: '',
      codFilial: '',
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
      colaborador:'',
      colaboradoresSeleccionados: [],
      checkAttach:[{'id':'0001','descripcion':'Adjuntar Resumen FV'},
                   {'id':'0002','descripcion':'Adjuntar Proforma'}],
      coloresProformaList:[],
      estadoTrama:'1',
      mensajeTrama:'',
      muestraLoad:'none',
      fichaVentaDeProformaQueYaSeAsigno:'',
      nroProforma: '',
      indCondicionCertificados:0,
      /*Inicio Req 93426 ebarboza 29 11 2021*/
      welcomePackProforma:[], 
      errorWelcomePack:false,
      estadoTramaWelcomePack:"",
      mensajeWelcomePack:"",
      numProfWelcomePack:"",
      proformasWelcomePack:[],
      isOpenModelGetWelcomePack:false,
      equipoAdicionalLocalList:[],
      selectEquipoWelcomePack:[],
      checkedWelcomePack: false,
      welcomePackMostrar:[]
    /*Fin Req 93426 ebarboza 29 11 2021*/
    };
  }

  changeIndCondicionCertificados = () => {
    this.setState({indCondicionCertificados:1})
  }

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  loading =(value)=>{
    this.setState({muestraLoad:value});
  }

  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const correo = this.props.colaboradores
          .filter(({ idUsuario }) => idUsuario.toString() === key)[0].correo;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}`, correo : correo };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }

  onChangeValue = e => {
    console.log(e);
      this.setState({ [e.target.name]: e.target.value })
  }

  componentDidMount() {


    this.props.fetchCompanias();
    this.props.fetchAreasVenta();
    this.props.fetchReglasNegocio(VACIO,VACIO,VACIO,VAR_REGLA_NEGOCIO);
    //Inicio Req - 90917_L_Absorcion_Legados_Fase_2
    const { 
      //cliente, 
      proforma } = this.props.querys;
      if(proforma != undefined){
        this.props.obtenerProformaCliente(proforma).then(data => {

            const cliente = data.payload.data.codCliente;
              if (cliente && cliente.length === 8) {
                  this.search('codcliente', cliente);
                  this.props.fetchClientes('codcliente', cliente)
                    .then(() => this.showClientProform(this.props.clientes.data[0]))
                    .then(() => this.props.searchProformas(null, proforma))
                    .then(() => {
                      console.log('this.props.proformas.listConsultaProforma',this.props.proformas.listConsultaProforma);
                      console.log('this.props.proformas.listConsultaProforma',proforma);
                      if (this.props.proformas.listConsultaProforma.length && proforma) {
                        this.selectProform(this.props.proformas.listConsultaProforma[0]);
                      }else{
                        this.loading('')
                        this.searchFDV(0,proforma);
                      }
                    });
                }
            });
      }
    //Fin Req - 90917_L_Absorcion_Legados_Fase_2
    this.props.fetchColaboradores(VACIO);
  }

  searchFDV = (option,proforma) => {
    this.setState({fichaVentaDeProformaQueYaSeAsigno:''})//<I-92416>
    this.loading('block')
    this.setState({nroProforma:proforma})
      this.props.fetchFichasVenta('', '1', '1', 'nproforma', proforma)
        .then(() => {
          const fichasVenta = this.props.fichasVenta.fichaVentaResponse;
            const fdvID =fichasVenta[0] === undefined?undefined:fichasVenta[0].numFichaVtaVeh;
            this.setState({fichaVentaDeProformaQueYaSeAsigno:'La Proforma ya fue asignada a la Ficha de Venta N°' + fdvID})
            if(option===1){
              window.history.pushState({}, '', `/fichas-venta/${fdvID}`);
              window.location.reload();
            }
            this.loading('')

        });
    }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })
  onChangeSelect = e => this.setState({ [e.target.name]: e.target.value, searchInput: '' })
  onCheck = (e) => {
    if (this.state[e.target.name] === e.target.value) {
      this.setState({ [e.target.name]: '' });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  onChangeVendedores = (e) => {
    if (e.target.value.length >= 2) {
      this.props.fetchVendedores(e.target.value);
    }
    if (e.target.value.length === 0) {
      this.props.clearVendedores();
    }
    this.setState({ vendedorName: e.target.value });
  }

  onSelectVendedores = (key) => {
    this.setState({
      vendedorName: this.props.vendedores
                  .filter(({ vendedor }) => vendedor === key)[0].descripcion,
      vendedorId: key,
    }, () => this.searchByFilter());
    this.props.clearVendedores();
  }

  setProformas = () => {
    if (this.state.selectedProform.length === 1) {
      const {
        codCliente,
        codAreaVta,
        codCia,
        codFilial,
        codVendedor,
        vendedor,
      } = this.state.selectedProform[0];
      this.setState({
        areaVentaFilter: codAreaVta,
        companyFilter: codCia,
        codFilial,
        vendedorName: vendedor,
        vendedorId: codVendedor,
        stillSearch: false,
      });
      this.props.searchProformas(codCliente, null, codAreaVta, codCia, codVendedor);
      this.setState({
        companyValue: codCia,
        proformasTable: true,
        clientName: this.state.selectedProform[0].cliente,
        clientId: this.state.selectedProform[0].codCliente,
      });
    }
  }

  onChangeCondicionCertificados = (condicionesProforma) => {
    this.setState({condicionesProforma:condicionesProforma})
  }

  backToStep1 = () => {
    this.setState({
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
      observaciones: '',
      indCondicionCertificados:0
    });
    this.previousStep();
  }

  goToStep3 = (...object) => {
    this.setState({ SecondStep: object[0] });
    this.nextStep();
  }

  searchByVendedor = () => {
    if (this.state.vendedorName.length === 0) {
      this.setState({
        vendedorId: '',
      }, () => this.searchByFilter());
    }
    this.searchByFilter();
  }

  nextStep = () => {
    //<I-92416_L_Mejorar_crear_fdv_con_reserva_para_autos_preasignar_pedidos>
    //queda pendiente caso cuando selecciona varias proformas debe  iterar y consultar cada una de ellas.
    const proformas =  this.state.selectedProform;
    let checkedWelcomePack = this.state.checkedWelcomePack
    var sinReserva = false; 
    /*Inicio Req 93426 ebarboza 29 11 2021*/
    
    const welcomePackProforma = []
    if (this.state.step === 2){
      
       if(!this.crearAlertWelcomePack()){
          return
       }
     }
    /*Fin Req 93426 ebarboza 29 11 2021*/
    console.log("this.state.step _ "+this.state.step);
    if (this.state.step === 1){
      console.log(this.state.selectedProform[0]);
      proformas.forEach((proforma, index) => {
        const promises = [];/*Req 93426 ebarboza 29 11 2021*/
        console.log(proforma);
        promises.push(this.props.validateProforma(proforma.nroProforma)); /*Req 93426 ebarboza 29 11 2021*/
        promises.push(this.props.fetchFichaVentaWelcomePackValidar(proforma.nroProforma));/*Req 93426 ebarboza 29 11 2021*/
        Promise.all(promises).then(result => {
          /*Inicio Req 93426 ebarboza 29 11 2021*/
          if(result[1].payload.data.estadoTrama==="0" && !checkedWelcomePack){
            welcomePackProforma.push(result[1])
            this.showAndHideAlertWelcPack(result[1]);
            this.setState({welcomePackProforma:welcomePackProforma,checkedWelcomePack:false})/*Req 93426 ebarboza 29 11 2021*/
          }else if(result[1].payload.data.estadoTrama==="1" && result[1].payload.data.codEquipo !=="" && result[1].payload.data.codEquipo !== null && result[1].payload.data.codEquipo !== undefined){
            const proformas = this.state.selectedProform;
            let equipoAdicionalLocalList = this.state.equipoAdicionalLocalList
            let proforma = []
            if (proformas !== null && proformas !== undefined) {
              proforma = proformas.filter(x => x.nroProforma === result[1].payload.data.numProfVeh)
            }
            this.props.fetchWelcomePackValidar(proforma[0]).then(resultEquipo => {
              if (resultEquipo.payload.data.estadoTrama === "1") {
                let welcomePackMostrar = []
                let equipoProforma = []
                if(resultEquipo.payload.data.cantidad > 0 && resultEquipo.payload.data.equipoAdicionalLocalList){
                  equipoProforma = resultEquipo.payload.data.equipoAdicionalLocalList.filter((equipo,index) => {return equipo.codEquipo === result[1].payload.data.codEquipo})
                  if(equipoProforma !== null && equipoProforma !== undefined ){
                  welcomePackMostrar.push(equipoProforma[0].codEquipo+"---"+equipoProforma[0].descEquipo)
                                  
                  }else{
                    welcomePackProforma.push(result[1])
                    this.showAndHideAlertWelcPack(result[1]);
                    this.setState({welcomePackProforma:welcomePackProforma,checkedWelcomePack:false})
                  }
                }
                this.setState({welcomePackMostrar: welcomePackMostrar, selectEquipoWelcomePack:equipoProforma})  
              }
            });
          }
          
          /*Fin Req 93426 ebarboza 29 11 2021*/
          console.log('result:: ',result);
          if(result[0].payload.data.estadoTrama==0){
            this.setState({estadoTrama:result[0].payload.data.estadoTrama})
            this.setState({mensaje:result[0].payload.data.mensaje})
            sinReserva = true;
            this.showAndHideAlert(result[0].payload.data.mensaje);
          }
         
        });
      }); 
      if(sinReserva === false){
        this.setState({ step: this.state.step + 1 });
        this.setState({estadoTrama:'1'})
      }
      if (this.state.step + 1  === 2) {
        this.fnLoadProformaColor();
      }
      
    }else{
    //<F-92416_L_Mejorar_crear_fdv_con_reserva_para_autos_preasignar_pedidos> 
    if(this.state.estadoTrama !== '1') {
      console.log('Alert Paso 3:: ')
      this.state.mensaje !== null || this.state.mensaje !== undefined?
       this.showAndHideAlert(this.state.mensaje):this.showAndHideAlert(this.state.errorMessage);
    } else {
      this.setState({ step: this.state.step + 1});
    }
  }

  }
  previousStep = () => this.setState({ step: this.state.step - 1 })
  paginateClient = ({ selected }) => {
    this.props.fetchClientes(this.state.lastOption, this.state.lastInput, selected + 1);
  }

  paginateProform = ({ selected }) => {
    this.props.searchProformas(this.state.clientId, '', this.state.areaVentaFilter, this.state.companyFilter, this.state.vendedorId, selected + 1);
  }

  goToClients = () => {
    this.setState({ clientTable: true, proformTable: false, stillSearch: true, clientName: '', companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
  }

  showAndHideAlert = (message) => {
    console.log('message',message);
    this.setState({ hasError: true, errorMessage: message });
    setTimeout(() => this.setState({ hasError: false }), 5000);
  }

  showClientProform = (client) => {
    const { proforma } = this.props.querys;
    validateClient(client.codigo, 0)
      .then(({ estadoTrama, mensaje }) => {

        if (estadoTrama === '1') {
          this.props.clearProformasBuscar();
          if (!proforma) {
            this.props.searchProformas(client.codigo);
          }
          this.setState({
            clientTable: false,
            proformTable: true,
            stillSearch: false,
            clientName: client.nombre,
            clientId: client.codigo,
          });
        } else if (estadoTrama === '0' || estadoTrama === '-1') {
          console.log('estadoTrama',estadoTrama);
          this.setState({estadoTrama:estadoTrama})
          this.setState({estadoTrama:mensaje})
          this.showAndHideAlert(mensaje);
        } else {
          this.setState({estadoTrama:'-1'})
          this.setState({estadoTrama:`Hubo un error con el servicio ${estadoTrama}`})
          this.showAndHideAlert(`Hubo un error con el servicio ${estadoTrama}`);
        }
      });
  }

  selectProform = (proforma) => {

    const { selectedProform } = this.state;
    console.log('selectedProform',selectedProform);
    if (selectedProform.filter(({ nroProforma }) => nroProforma === proforma.nroProforma).length) {

      if (selectedProform.length === 1) {
        this.props.searchProformas(this.state.clientId);
        this.setState({ companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
      } else {
        this.setState({
          selectedProform: selectedProform
                            .filter(({ nroProforma }) => nroProforma !== proforma.nroProforma),
        });
      }
    } else {
      this.props.fetchEquiposLogisticaDetalle(proforma.nroProforma, VACIO, VACIO, 0, 0).then(entry =>{
        console.log('entry.payload.data.dataVehiculo',entry.payload.data.dataVehiculo);
        console.log('entry.payload.data.dataVehiculo',proforma);
        this.setState({
          selectedProform: [...this.state.selectedProform, Object.assign({},proforma,{'proformaDetail':entry.payload.data.dataVehiculo})],
        }, this.setProformas);

      })

    }
  }

  unselectProforma = (proforma) => {
    if (this.state.selectedProform.length === 1) {
      this.props.searchProformas(this.state.clientId);
      this.setState({ companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
    } else {
      this.setState({
        selectedProform: this.state.selectedProform.filter(it => it !== proforma.proforma),
      });
    }
  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }

  search = (option, value) => {
    this.setState({fichaVentaDeProformaQueYaSeAsigno:''})//<I-92416>
    if (!value.trim() || (option === 'nroProforma' && value.length !== 10)) {
      return false;
    } else if (this.state.searchOption === 'nroProforma') {
      this.setState({
        lastInput: this.state.searchInput,
        lastOption: this.state.searchOption,
        searchByProforma: true,
        clientTable: false,
        proformTable: true,
        selectedProform: [],
      });
      this.props.clearProformasBuscar();

      //<I-92416_L_Mejorar_crear_fdv_con_reserva_para_autos_preasignar_pedidos>
      this.loading('block')
      this.setState({nroProforma:value})
        this.props.fetchFichasVenta('', '1', '1', 'nproforma', value)
          .then((response) => {
            console.log(response);
            const fichasVenta = this.props.fichasVenta.fichaVentaResponse;
              const fdvID =fichasVenta[0] === undefined?undefined:fichasVenta[0].numFichaVtaVeh;
              console.log(fdvID);
              if(fdvID===undefined){
                this.props.searchProformas(null, value);
              }else{
              this.setState({fichaVentaDeProformaQueYaSeAsigno:'La Proforma ya fue asignada a la Ficha de Venta N°' + fdvID})
              }
              this.loading('')
  
          });
      //this.props.searchProformas(null, value);
      //<F-92416_L_Mejorar_crear_fdv_con_reserva_para_autos_preasignar_pedidos>
      return true;
    }
    this.setState({
      lastInput: this.state.searchInput,
      lastOption: this.state.searchOption,
      clientTable: true,
      proformTable: false,
    });
    this.props.clearClientes();
    this.props.fetchClientes(option, value);
    return true;
  }



  searchByFilter = () => {
    // document.querySelectorAll('.customToggle').forEach(dropdown => dropdown.classList.remove('open'));
      var lista=document.querySelectorAll('.customToggle');
      for (var i = 0; i < lista.length; i++) {
          lista[i].classList.remove('open');
      }
    this.props.clearProformasBuscar();
    this.props.searchProformas(this.state.clientId, '', this.state.areaVentaFilter, this.state.companyFilter, this.state.vendedorId);
    this.setState({ selectedProform: [] });
  }

  fnDefaultColorProforma = (proforma, index) => {
    const businessRolesList = this.props.reglasNegocio.businessRolesList;
    const proformas =  this.props.proformas.listConsultaProforma;
    if(businessRolesList.map(entry => {return entry.reglas}).indexOf( proformas.filter(entry => entry.nroProforma===proforma)[0].codAreaVta)>=0){
      return true;
    }
    return false;
  }

  fnLoadProformaColor = () => {
    const proformas =  this.state.selectedProform;
    let coloresProformaList = [];

    proformas.forEach((proforma, index) => {
      console.log('logger',this.fnDefaultColorProforma(proforma.nroProforma, index));
        if(this.fnDefaultColorProforma(proforma.nroProforma, index)){
          coloresProformaList=[...coloresProformaList,{[proforma.nroProforma]:[proforma.proformaDetail.codColorPintura+'---'+proforma.proformaDetail.colorPintura]}]
        }else{
          coloresProformaList=[...coloresProformaList,{[proforma.nroProforma]:['']}]
        }
      })

      this.setState({ coloresProformaList:coloresProformaList});
  }

  fnSetSoloresProformaList = (coloresProformaList) =>{
    this.setState({coloresProformaList:coloresProformaList})

  }

  closeModal=()=>{
    this.setState({indCondicionCertificados:0})
    this.props.closeModal();
  }
  /*Inicio Req 93426 ebarboza 29 11 2021*/
  showAndHideAlertWelcPack = (result) => {
    if (result.payload.data.estadoTrama === "0") {
      this.setState({
        mensajeWelcomePack: result.payload.data.mensaje,
        numProfWelcomePack: "La Proforma: " + result.payload.data.numProfVeh
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);

    }
  };

  crearAlertWelcomePack = () => {
    const welcomePack = this.state.welcomePackProforma
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    let contador = 0
    if (selectEquipoWelcomePack.length > 0 && selectEquipoWelcomePack.length < 2) {
      return true
    }
    if (selectEquipoWelcomePack.length > 1) {
      this.setState({
        mensajeWelcomePack: "Welcome Pack",
        numProfWelcomePack: "Debe seleccionar un solo"
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
      return false
    }

    if (welcomePack !== null || welcomePack !== undefined) {
      welcomePack.map((x) => {
        if (x.payload.data.estadoTrama === "0") {
          contador++
          contador < 2 ?
            this.setState({
              mensajeWelcomePack: x.payload.data.mensaje,
              numProfWelcomePack: "La Proforma: " + x.payload.data.numProfVeh
            }) :
            this.setState({
              mensajeWelcomePack: x.payload.data.mensaje,
              numProfWelcomePack: "Mas de Una Proforma"
            })
          this.setState({ errorWelcomePack: true });
          setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
        }
      })
    }

    return contador >= 1 ? false : true
  }

  getFetchWelcomePack = (nroProforma, index) => {
    const proformas = this.state.selectedProform;
    let equipoAdicionalLocalList = this.state.equipoAdicionalLocalList
    let proforma = []
    if (proformas !== null && proformas !== undefined) {
      proforma = proformas.filter(x => x.nroProforma === nroProforma)
    }
    this.props.fetchWelcomePackValidar(proforma[0]).then(result => {
      console.log('fetchWelcomePackValidar: ', result)
      if (result.payload.data.estadoTrama === "1") {
        equipoAdicionalLocalList = result.payload.data.equipoAdicionalLocalList
        this.setState({ equipoAdicionalLocalList: equipoAdicionalLocalList })
        this.isOpenModelGetWelcomePack();
      }
    });
  }
  isOpenModelGetWelcomePack = () => {
    this.setState({ isOpenModelGetWelcomePack: this.state.isOpenModelGetWelcomePack ? false : true })
  }

  fnMostrarGridWelcomePack = () => {
    let equipoAdicionalLocalList = this.state.equipoAdicionalLocalList
    if (equipoAdicionalLocalList !== null && equipoAdicionalLocalList !== undefined) {
      if (equipoAdicionalLocalList.length) {
        return equipoAdicionalLocalList.map((equipoWelcomePack, index) => (
          <tr key={index}>
            <td style={{ width: "15%" }}>
              <div className='checkbox checkbox-inline'>
                <label>
                  <input key={equipoWelcomePack.codEquipo} name={equipoWelcomePack.codEquipo} type='checkbox' checked={this.state.selectEquipoWelcomePack.length > 0 ? this.state.selectEquipoWelcomePack.filter(x => x.codEquipo === equipoWelcomePack.codEquipo).length > 0 ? true : false : false}/>
                  <div className='checkbox-skin' onClick={() => this.selectWelcomePack(equipoWelcomePack)} />
                </label>
              </div>
            </td>
            <td style={{ width: "20%" }}>{equipoWelcomePack.codEquipo}</td>
            <td style={{ width: "65%" }}>{equipoWelcomePack.descEquipo}</td>
          </tr>
        ));
      }
      return <tr><td style={{ width: "100%" }} className='no-before' colSpan={12}>No hay resultados</td></tr>;
    }

  }
  selectWelcomePack = (equipoWelcomePack) => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    console.log("Seleccion:: ",...selectEquipoWelcomePack)
    if (selectEquipoWelcomePack.filter(x => x.codEquipo === equipoWelcomePack.codEquipo).length > 0) {
     this.setState({selectEquipoWelcomePack:selectEquipoWelcomePack.filter(x => x.codEquipo !== equipoWelcomePack.codEquipo)})
    } else {
      this.setState({selectEquipoWelcomePack:[...selectEquipoWelcomePack,equipoWelcomePack]})
    }
}
  agregarWelcomePack = () => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    if (selectEquipoWelcomePack.length > 1) {
      this.setState({
        mensajeWelcomePack: "WELCOME PACK",
        numProfWelcomePack: "Solo debe seleccionar un"
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
      return false
    }else{
    let welcomePackMostrar = []
    selectEquipoWelcomePack.map(x => {welcomePackMostrar.push(x.codEquipo+"---"+x.descEquipo)})
    this.setState({welcomePackMostrar:welcomePackMostrar})
    }
    this.setState({ checkedWelcomePack: selectEquipoWelcomePack.length > 0 ? true : false })
    this.isOpenModelGetWelcomePack()
  }

  mostrarWelcomePack = () => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    return (
      <table key={"mostrarWelcomePack"} class="table">
        <thead>
          <tr>
            <th key={"codigoEquipo"} scope="col">Codigo Welcome Pack</th>
            <th key={"descripcionEquipo"} scope="col">Descripción</th>
          </tr>
        </thead>
        <tbody>
          {selectEquipoWelcomePack.length > 0 ? selectEquipoWelcomePack.map((x, index) => {
            <tr>
              <td key={x.codEquipo + index}>{x.codEquipo}</td>
              <td key={x.codEquipo + index}>{x.descEquipo}</td>
            </tr>
          }) : null}
        </tbody>
      </table>
    )
  }
  /*Fin Req 93426 ebarboza 29 11 2021*/


  render() {
    const { clientes, proformas, companias, areasVenta, vendedores } = this.props;
    const {
      step, searchInput, searchOption, clientTable,
      hasError, proformTable, selectedProform, clientName,
      searchByProforma, stillSearch, companyFilter, areaVentaFilter,
      clientId, vendedorId, codFilial,errorWelcomePack,isOpenModelGetWelcomePack,checkedWelcomePack,selectEquipoWelcomePack
    } = this.state;
    const stepsTitle = ['Asociar proforma', 'Condiciones de entrega', 'Confirmar'];

    return (
      <div>
        <Modal isOpen idModal='nueva-fdv' modalSize='modal-dialog modal-lg' title='Nueva Ficha de Venta' closeModal={this.props.closeModal}>
          <div className='modalBleed'>
            <Steps stepsTitle={stepsTitle} step={step} />
          </div>
          <div className='steps-container fdvNew-slides'>
            {
            step === 1 &&
            <ErrorUIComponent>
              <FirstStep
                clientes={clientes}
                proformas={proformas}
                companias={companias}
                areasVenta={areasVenta}
                vendedores={vendedores}
                companyFilter={companyFilter}
                areaVentaFilter={areaVentaFilter}
                searchOption={searchOption}
                searchInput={searchInput}
                clientTable={clientTable}
                proformTable={proformTable}
                searchByProforma={searchByProforma}
                selectedProform={selectedProform}
                clientName={clientName}
                vendedorName={this.state.vendedorName}
                stillSearch={stillSearch}
                nextStep={this.nextStep}
                onChangeValue={this.onChangeValue}
                onCheck={this.onCheck}
                onChangeSelect={this.onChangeSelect}
                search={this.search}
                paginateClient={this.paginateClient}
                showClientProform={this.showClientProform}
                selectProform={this.selectProform}
                paginateProform={this.paginateProform}
                goToClients={this.goToClients}
                unselectProforma={this.unselectProforma}
                searchByFilter={this.searchByFilter}
                fetchVendedores={this.props.fetchVendedores}
                clearVendedores={this.props.clearVendedores}
                onChangeVendedores={this.onChangeVendedores}
                onSelectVendedores={this.onSelectVendedores}
                searchByVendedor={this.searchByVendedor}
                estadoTrama={this.state.estadoTrama}
                fichaVentaDeProformaQueYaSeAsigno = {this.state.fichaVentaDeProformaQueYaSeAsigno}
                searchFDV = {this.searchFDV}
                nroProforma = {this.state.nroProforma}
              />
            </ErrorUIComponent>
          }
            {
            step === 2 &&
            <ErrorUIComponent>
              <SecondStep
                nextStep={this.goToStep3}
                previousStep={this.backToStep1}
                proformas={selectedProform}
                codAreaVta={areaVentaFilter}
                {...this.state.SecondStep}
                observaciones={this.state.observaciones}
                onChangeValue={this.onChangeValue}
                reglasNegocio={this.props.reglasNegocio}
                fnDefaultColorProforma={this.fnDefaultColorProforma}
                coloresProformaList={this.state.coloresProformaList}
                fnSetSoloresProformaList={this.fnSetSoloresProformaList}
                onChangeCondicionCertificados={this.onChangeCondicionCertificados}
                changeIndCondicionCertificados={this.changeIndCondicionCertificados}
                indCondicionCertificados={this.state.indCondicionCertificados}
                nuevaFDV
                /*Inicio Req 93426 ebarboza 29 11 2021 */
                getFetchWelcomePack={this.getFetchWelcomePack}
                mostrarWelcomePack={this.mostrarWelcomePack}
                checkedWelcomePack={checkedWelcomePack}
                selectEquipoWelcomePack={selectEquipoWelcomePack}
                /*Fin Req 93426 ebarboza 29 11 2021 */
              />
            </ErrorUIComponent>
          }
            {
            step === 3 &&
            <ErrorUIComponent>
              <ThirdStep
                previousStep={this.previousStep}
                proformas={selectedProform}
                codAreaVta={areaVentaFilter}
                codCia={companyFilter}
                codCliente={clientId}
                codFilial={codFilial}
                codVendedor={vendedorId}
                colaboradores={this.props.colaboradores}
                colaborador={this.state.colaborador}
                changeColaborador={this.changeColaborador}
                selectColaborador={this.selectColaborador}
                removeColaborador={this.removeColaborador}
                colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
                checkAttach={this.state.checkAttach}
                {...this.state.SecondStep}
                obsFichaVtaVeh={this.state.observaciones}
                nuevaFDV
                coloresProformaList={this.state.coloresProformaList}
                /*Inicio Req 93426 ebarboza 29 11 2021 */
                selectEquipoWelcomePack={this.state.welcomePackMostrar}
                welcomePackEquipo={selectEquipoWelcomePack}
                /*Fin Req 93426 ebarboza 29 11 2021 */
              />
            </ErrorUIComponent>
          }
          </div>
        </Modal>
        {
          hasError &&
            <Alert type='alert-warning over-modal' icon='ion-alert-circled'>
              <p>{this.state.errorMessage}</p>
            </Alert>
        }{/*Inicio Req 93426 ebarboza 29 11 2021 */
          errorWelcomePack && <AlertWelcomePack 
          titulo={'ALERTA WELCOME PACK'}
          mensajeWelcomePack={this.state.mensajeWelcomePack}
          numProfWelcomePack={this.state.numProfWelcomePack}
          />/*Fin Req 93426 ebarboza 29 11 2021 */
        }

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ zIndex: '2000', display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
        {/*Inicio Req 93426 ebarboza 29 11 2021 */}
        <Modal isOpen={isOpenModelGetWelcomePack} idModal='agregar-welcome-pack' modalSize='modal-dialog modal-lg' title='Welcome Pack' closeModal={this.isOpenModelGetWelcomePack}>
          <div className='modalBleed'>
            <table class="table table-dark">
              <thead>
                <tr>
                  <th style={{width:"15%"}} scope="col-2">Check</th>
                  <th style={{width:"20%"}} scope="col-3">Cod. Welcome Pack</th>
                  <th style={{width:"65%"}} scope="col-7">Descripción</th>
                </tr>
              </thead>
              <tbody>
              {this.fnMostrarGridWelcomePack()}
              </tbody>
            </table>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', minHeight: '55px', justifyContent: 'center', alignItems: 'end'}}>
             <div>
             <button class="btn btn-primary open" onClick={()=>this.agregarWelcomePack()}>Guardar</button>
            </div>
          </div>
        </Modal>
        {/*Fin Req 93426 ebarboza 29 11 2021 */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientes: state.clientes,
    proformas: state.proformasBuscar,
    companias: state.companias,
    areasVenta: state.areasVenta,
    vendedores: state.vendedores,
    colaboradores : state.colaboradores,
    equiposLogistica: state.equiposLogistica,
    reglasNegocio: state.reglasNegocio,
    fichasVenta: state.fichasVenta
  };
}

export default connect(mapStateToProps,
  {
    fetchClientes,
    clearClientes,
    searchProformas,
    clearProformasBuscar,
    fetchCompanias,
    fetchAreasVenta,
    fetchVendedores,
    clearVendedores,
    fetchColaboradores,
    clearColaboradores,
    fetchEquiposLogisticaDetalle,
    fetchReglasNegocio,
    fetchFichasVenta,
    /*Inicio Req ebarboza 29 11 2021 */
    fetchFichaVentaWelcomePackValidar,
    validateProforma,
    fetchWelcomePackValidar
    /*Fin Req ebarboza 29 11 2021 */
    //Inicio Req - 90917_L_Absorcion_Legados_Fase_2
    ,obtenerProformaCliente
    //Inicio Req - 90917_L_Absorcion_Legados_Fase_2
  })(NuevaFichaVenta);



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/index.js